let currentSlide = 0;
const slideElements = document.querySelectorAll(".slide");
const totalSlides = slideElements.length;
const dotsContainer = document.querySelector(".dots");
const carousel = document.getElementById("carousel");
const videoDuration = 90;

slides.forEach((_, i) => {
  const dot = document.createElement("div");
  dot.classList.add("dot");
  dot.onclick = () => goToSlide(i);
  dotsContainer.appendChild(dot);
});

function changeSlide(direction) {
  currentSlide = (currentSlide + direction + totalSlides) % totalSlides;
  updateCarousel();
}

function goToSlide(index) {
  currentSlide = index;
  updateCarousel();
}

function updateCarousel() {
  const slideWidth = 80; // each slide occupy 80% width
  const offset = -currentSlide * slideWidth + 10; // +10 previous slide's 10%
  carousel.style.transform = `translateX(${offset}%)`;

  slideElements.forEach((slide, index) => {
    slide.classList.toggle("active", index === currentSlide);
    const video = slide.querySelector("iframe");

    if (index === currentSlide) {
      video.play();
      video.addEventListener("timeupdate", handleTimeUpdate);
    } else {
      video.pause();
      video.removeEventListener("timeupdate", handleTimeUpdate);
    }
  });

  dots.forEach((dotElement, index) => {
    dotElement.classList.toggle("active", index === currentSlide);
  });
}

function handleTimeUpdate(event) {
  const video = event.target;
  if (video.currentTime >= videoDuration) {
    video.currentTime = 0;
    changeSlide(1);
  }
}

updateCarousel();

// Autoplay logic
let userHasInteracted = false;
let autoplayInterval;

function startAutoplay() {
  if (!autoplayInterval && userHasInteracted) {
    autoplayInterval = setInterval(() => changeSlide(1), videoDuration * 1000);
  }
}

function stopAutoplay() {
  clearInterval(autoplayInterval);
  autoplayInterval = null;
}

function handleUserInteraction() {
  userHasInteracted = true;
  startAutoplay();
}

document.addEventListener("click", handleUserInteraction);
carousel.addEventListener("touchstart", handleUserInteraction);
carousel.addEventListener("mouseenter", stopAutoplay);
carousel.addEventListener("mouseleave", startAutoplay);

// Swipe handling
let touchStartX = 0;
let touchEndX = 0;

function handleSwipe() {
  if (touchStartX - touchEndX > 15) {
    changeSlide(1);
  } else if (touchEndX - touchStartX > 15) {
    changeSlide(-1);
  }
}

carousel.addEventListener(
  "touchstart",
  (e) => (touchStartX = e.changedTouches[0].screenX)
);
carousel.addEventListener("touchend", (e) => {
  touchEndX = e.changedTouches[0].screenX;
  handleSwipe();
});
